import { __awaiter, __extends, __generator } from "tslib";
import GoogleAnalyticsGTagClient from "../../../googleAnalytics/GoogleAnalyticsGTagClient";
import RequestTypes from "../../RequestTypes";
import AbstractAdapter from "./AbstractAdapter";
/**
 * Google analytics 4 gtag adapter.
 */
var Gtag = /** @class */ (function (_super) {
    __extends(Gtag, _super);
    function Gtag() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Gtag.prototype._record = function (request, rawRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var adapter, response, client, setRequest, _a, key, value, trackRequest, properties, event_1, nonInteraction, error_1;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getName()];
                    case 1:
                        adapter = _c.sent();
                        response = {
                            adapter: adapter,
                            finalRequest: request,
                            isResponseConfirmed: false,
                            isSuccess: true,
                        };
                        try {
                            if (JSON.stringify(request) !== JSON.stringify(rawRequest)) {
                                response.rawRequest = rawRequest;
                            }
                        }
                        catch (error) { }
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.getClient()];
                    case 3:
                        client = _c.sent();
                        switch (request.type) {
                            case RequestTypes.Alias:
                                throw new Error("Not implemented");
                            case RequestTypes.Set:
                                setRequest = request;
                                _a = setRequest.properties, key = _a.key, value = _a.value;
                                client.set("user_properties", (_b = {},
                                    _b[key] = value,
                                    _b));
                                response.meta = {
                                    key: key,
                                    value: value,
                                };
                                break;
                            case RequestTypes.Identity:
                                throw new Error("Not implemented");
                            case RequestTypes.Page:
                                throw new Error("Not implemented");
                            case RequestTypes.Track:
                                trackRequest = request;
                                properties = trackRequest.properties;
                                event_1 = trackRequest.event;
                                nonInteraction = !trackRequest.isUserInteraction;
                                if (this.debug) {
                                    properties.debug = true;
                                }
                                client.event(event_1, properties);
                                response.meta = {
                                    type: "event",
                                    event: event_1,
                                    properties: properties,
                                    nonInteraction: nonInteraction,
                                };
                                break;
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _c.sent();
                        response.error = error_1;
                        response.isSuccess = false;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, response];
                }
            });
        });
    };
    Gtag.prototype.getName = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, "Gtag"];
            });
        });
    };
    Gtag.prototype.getClient = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.client) {
                    this.client = new GoogleAnalyticsGTagClient({ trackerBlacklist: this.trackerBlacklist });
                }
                return [2 /*return*/, this.client];
            });
        });
    };
    return Gtag;
}(AbstractAdapter));
export default Gtag;
//# sourceMappingURL=GTag.js.map